import React from "react"
import { graphql, Link } from "gatsby"
import { GatsbyImage, getImage } from "gatsby-plugin-image"

const ListCard = ({ article }) => {

  const isVideo = article.cover?.mime?.startsWith("video")
  const isGerman = typeof window !== 'undefined' && window.location.pathname.includes('/de');

  return (
    <Link to={`/${isGerman ? 'de/' : ''}${article.slug}`} className="list-card border-b-4 border-black first:border-t-4 bg-white hover:bg-black hover:text-white transition duration-200">
      <div className="col-span-1 px-4 md:px-8">
        <div className="flex items-center">
          <div className="w-32 h-24 sm:h-20 md:w-56 md:h-32 flex-none">
            {isVideo ? (
              <div className="h-full w-full"
                dangerouslySetInnerHTML={{ __html: `<video class="allianz-player object-cover h-full w-full" playsinline autoplay loop muted><source src="${article.videocover.file.url}" type="video/mp4" /></video>` }}
              />
            ) : (
              <GatsbyImage
                image={getImage(article.cover?.file)}
                alt={article.cover?.alternativeText || "Alternative Text missing"}
                className="h-full w-full aspect-video"
              />
            )}
          </div>
          <div className="px-4 md:px-24 grow">
            <h2 className="text-headline-listfeed tracking-text leading-none font-semibold -mt-1.5 md:-mt-2">{article.title}</h2>
          </div>
        </div>
      </div>
    </Link>
    )
  }

  export const query = graphql`
    fragment ListCard on StrapiArticle {
      id
      slug
      title
      description
      publishedAt
      options
      tags {
        name
        slug
        description
      }
      videocover: cover {
        caption
        name
        mime
        alternativeText
        file {
          url
        }
      }
      cover {
        caption
        name
        mime
        alternativeText
        file {
          url
          childImageSharp {
            gatsbyImageData(aspectRatio: 1.5)
          }
        }
      }
    }
  `
export default ListCard
